<template>
  <div class="table_container">
    <div>
      <TableHeader
        :title="tableTitle"
        :total="totalItems"
        :totalDetails="totalDetails"
        @updateVisible="handleVisibleUpdate"
        @addClick="handleAddClick"
      />

      <p v-show="totalItems === 0" class="no_data">No data to show</p>

      <div v-show="items.length > 0" class="table header">
        <div>Source</div>
        <div>Type</div>
        <div class="item_status">Status</div>
        <div>Last trained on</div>
        <div></div>
      </div>

      <ul v-show="items.length > 0" class="box">
        <li v-for="(item, index) of items" class="table body">
          <div class="item">
            <button
              @click="handleItemClick(item)"
              @mouseover="handleItemHover(item.id)"
              @mouseleave="handleItemHover(null)"
              :disabled="
                item.status === 'processing' ||
                item.status === 'pending' ||
                item.status === 'unsubscribed'
              "
            >
              {{ item.source }}
            </button>

            <transition name="hovered_item">
              <div v-show="hoverItemData === item.id" class="data">
                <div class="data_arrow" />
                {{ item.source }}
              </div>
            </transition>
          </div>

          <div>
            {{ item.type ? item.type : "-" }}
          </div>

          <div
            class="item_status"
            v-bind:class="{
              item_trained: item.status === 'success',
              item_training: item.status === 'processing',
              item_stopped: item.status === 'stopped',
              item_error:
                item.status === 'error' || item.status === 'unsubscribed',
            }"
          >
            {{
              item.status
                ? item.status !== "processing"
                  ? item.status
                  : ""
                : "-"
            }}
            <svg v-show="item.status === 'processing'" class="item_svg">
              <use
                class="item_rotate"
                xlink:href="@/assets/img/Loader.svg#loader"
              />
            </svg>
          </div>

          <div>
            <span v-show="item.status === 'success'">{{
              getTimeFromLastTraining(item.finishedAt)
            }}</span>
          </div>

          <div class="actions">
            <button
              class="action__retrain"
              v-show="item.status === 'success' || item.status === 'error'"
              @click="handleRetrainClick(item)"
            >
              Retrain
            </button>

            <button
              class="action__upgrade"
              v-show="item.status === 'unsubscribed' || item.status === 'untrained'"
              @click="handleUpgradeClick()"
            >
              Upgrade
            </button>

            <button
              class="action__delete"
              v-show="item.status !== 'pending' || item.status !== 'processing'"
              @click="handleDeleteClick(item.id)"
            >
              Delete
            </button>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import TableHeader from "./TableHeader.vue";

export default {
  components: {
    TableHeader,
  },

  props: {
    title: {
      type: String,
      required: true,
    },

    items: {
      type: Array,
      required: true,
    },

    totalItemsCount: {
      type: Number,
      required: true,
    },

    totalItemsDetails: {
      type: String,
      required: false,
    },

    isModalOpen: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      hoverItemData: null,
    };
  },

  computed: {
    tableTitle() {
      return this.$props.title;
    },

    totalItems() {
      return this.$props.totalItemsCount;
    },
    totalDetails() {
      return this.$props.totalItemsDetails;
    }
  },

  methods: {
    getTimeFromLastTraining(date) {
      return moment(new Date(date)).fromNow();
    },

    handleItemHover(data) {
      this.hoverItemData = data;
    },

    handleAddClick() {
      this.$emit("addClick");
      gtag('event', 'links_add_click', {});
      amplitude.getInstance().logEvent('links_add_click', {});
    },

    handleVisibleUpdate(paginationData) {
      this.$emit("updateVisible", paginationData);
    },

    handleItemClick(item) {
      this.$emit("itemClick", item);
    },

    handleRetrainClick(item) {
      this.$emit("retrainClick", item);
      gtag('event', 'links_retrain_click', {});
      amplitude.getInstance().logEvent('links_retrain_click', {});
    },

    handleDeleteClick(itemId) {
      this.$emit("deleteClick", itemId);
      gtag('event', 'links_delete_click', {});
      amplitude.getInstance().logEvent('links_delete_click', {});
    },

    handleUpgradeClick() {
      this.$emit("upgradeClick");
      // this.$router.push({ path: "/user/dashboard" });
    },
  },
};
</script>

<style lang="scss" scoped>
.table_container {
  position: relative;
  overflow: auto;
  width: 100%;
  height: calc(100vh - 66px);
  padding: 62px 38px 38px 38px;

  @media screen and (max-width: 768px) {
    padding: 32px 16px;
  }
}

.box {
  max-width: 100%;
  padding: 0;
  margin: 0;
  flex-grow: 1;
}

.no_data {
  color: #637381;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 1.5;
}

.table {
  display: flex;

  @media screen and (min-width: 769px) {
    flex-direction: row;

    & > div:first-of-type {
      width: 50%;
    }
    & > div:nth-of-type(2),
    & > div:nth-of-type(3) {
      width: 10%;
      text-align: center;
    }
    & > div:nth-of-type(4),
    & > div:nth-of-type(5) {
      text-align: center;
      width: 25%;
    }
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;
    text-align: center;

    & > div {
      width: 100%;
      margin-top: 16px;
    }
  }
}

.header {
  @media screen and (max-width: 768px) {
    display: none;
  }
}

.item {
  position: relative;

  & > button {
    max-width: 345px;
    outline: none;
    background: transparent;
    border: none;
    padding: 0;
    margin: 0;
    color: #4f4f4f;
    transition: all ease-in-out 300ms;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:disabled {
      opacity: 0.5;
    }

    &:hover {
      color: #3056d3;
    }

    @media screen and (max-width: 420px) {
      text-align: center;
      max-width: 275px;
    }
  }
}
/*
.item:hover:not(:focus) {
  & > div {
    display: inline;
  }
} */

.data {
  position: absolute;
  display: inline;
  left: 0;
  top: calc((100% - 50px) * -1);
  padding: 8px;
  border-radius: 6px;
  background-color: #fff;
  z-index: 10;
  border: 1px solid #3056d3;
  color: #828282;

  &:after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    left: 5px;
    top: -8px;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 8px solid #3056d3;
    z-index: 9;
  }
}

.body {
  margin: 0;
  color: #828282;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.29;
  letter-spacing: -0.17px;
  padding: 10px 0;
  border-bottom: 1px solid #ededed;

  @media screen and (max-width: 768px) {
    padding: 16px 0;
  }

  & a {
    color: #828282;
    &:hover {
      color: #333;
      text-decoration: none;
    }
  }
}

.item_status {
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
}

.item_trained {
  color: #219653;
}

.item_training {
  color: #2f80ed;
}

.item_stopped {
  color: #cf9006;
}

.item_error {
  color: #eb5757;
}

.item_svg {
  width: 22px;
  height: 22px;
}

.item_rotate {
  animation: rotate 4s linear infinite;
  transform-origin: center;
}

.actions {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 16px;

  @media screen and (max-width: 768px) {
    justify-content: center;
  }

  & > button {
    outline: none;
    background: transparent;
    border: none;
    padding: 0;
    margin: 0;
  }

  & > .action__retrain {
    color: #333;
    border-bottom: 1px solid #333;
  }

  & > .action__upgrade {
    color: #2f80ed;
    border-bottom: 1px solid #2f80ed;
  }

  & > .action__delete {
    color: #eb5757;
    border-bottom: 1px solid #eb5757;
  }
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.hovered_item-enter-active,
.hovered_item-leave-active {
  transition: all 0.4s ease-in-out;
  opacity: 1;
}

.hovered_item-enter,
.hovered_item-leave-to {
  opacity: 0;
}
</style>
